<template>
    <div>
        <div v-if="!paymentPlans || paymentPlans.length < 1">
            <v-divider class="my-5 mx-0"></v-divider>
            <div class="not-fully-funded-note">We could not find any plans that match your search criteria</div>
            <v-divider class="my-5 mx-0"></v-divider>
        </div>

        <v-radio-group v-else v-model="selectedPaymentPlan" hide-details class="pt-0">
            <div v-for="(paymentPlan, index) in paymentPlans" :key="index" class="ma-0">
                <div v-if="index === firstNotFullFundedPlanIndex && index > 0">
                    <v-divider class="my-5 mx-0"></v-divider>
                    <div class="not-fully-funded-note">
                        Below are other options.<br />
                        Please note these do not match your active search criteria
                    </div>
                    <v-divider class="my-5 mx-0"></v-divider>
                </div>

                <!-- key and value are used by the radio group to associate selected index/value -->
                <PaymentPlanOption
                    :id="`payment-plan-${index}`"
                    :key="`payment-plan-${index}`"
                    :payment-plan="paymentPlan"
                    :provider-key="paymentPlan.providerKey"
                    :suggested-payment="isSuggestedPaymentIndex(index)"
                    :financed-amount-cents="financedAmountCents"
                    :fully-covered="isFullyCovered(paymentPlan, financedAmountCents)"
                />
            </div>
        </v-radio-group>
        <div v-if="isSynchronyPlanPresent" class="footer-special-message">
            {{ $t(`synchrony_standard.plan.expiration-language`) }}
        </div>
    </div>
</template>

<script>
    import PaymentPlanOption from "@/components/paymentplan/PaymentPlanOption.vue"
    import { isFullyCovered } from "@/util/plan"
    import ProviderKey from "@/model/provider/ProviderKey"

    export default {
        name: "PaymentPlanOptions",
        components: { PaymentPlanOption },
        props: {
            paymentPlans: {
                type: Array,
                required: true,
            },

            suggestedPayment: {
                type: Boolean,
            },

            financedAmountCents: {
                type: Number,
            },
            value: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                selectedPaymentPlan: this.value,
            }
        },

        computed: {
            firstNotFullFundedPlanIndex() {
                return this.paymentPlans.findIndex(plan => {
                    return !this.isFullyCovered(plan, this.financedAmountCents)
                })
            },

            /**
             * Need to display a specific footer if there is a Synchrony plan present
             * @returns {boolean}
             */
            isSynchronyPlanPresent() {
                return this.paymentPlans.some(response => response.providerKey.includes(ProviderKey.SYNCHRONY_STANDARD))
            },
        },
        watch: {
            value(data) {
                this.selectedPaymentPlan = data
            },
            selectedPaymentPlan(data) {
                this.selectedPaymentPlan = data
                this.$emit("input", data)
            },
        },
        methods: {
            isFullyCovered,
            // used for synchrony to toggle a label of "required payments" vs "suggested payments"
            isSuggestedPaymentIndex(index) {
                let highestPayment = 0
                let paymentIndex = 0

                this.paymentPlans.forEach((paymentPlan, index) => {
                    if (paymentPlan.monthlyAmountCents > highestPayment) {
                        highestPayment = paymentPlan.monthlyAmountCents
                        paymentIndex = index
                    }
                })
                return index === paymentIndex
            },
        },
    }
</script>

<style lang="scss">
    .not-fully-funded-note {
        text-align: center;
        font-size: 18px;
        font-style: italic;
        font-weight: 700;
        line-height: 28px; /* 155.556% */
        color: $grey-darken-1;
    }
</style>
